import { DiagramI, DiagramSearchListI } from '../types/diagram';

export const randomSlug = (): string => {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
};

export const cloneObject = (obj: any): any => {
  return JSON.parse(JSON.stringify(obj));
};

export const noop = (): void => {};

// parse JWT toke to get claims(username)
export const parseAccessToken = (token: string): Record<string, string> => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const getUsernameFromJWT = (accessToken: string): string => {
  const token = accessToken;
  if (token.length > 0) {
    return parseAccessToken(token).username;
  }
  return '';
};

export const isTokenExpired = (token: string): boolean => {
  const decoded = parseAccessToken(token);
  if (+decoded.exp < Date.now() / 1000) {
    return true;
  }
  return false;
};

export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const colorList: string[] = ['purple', 'cyan', 'green', 'yellow', 'red'];

export const getRandomColor = (): string => {
  const randomIndex = Math.floor(Math.random() * colorList.length);
  return colorList[randomIndex];
};

export const normalizeDiagramListForSearch = (
  diagramList: DiagramI[],
): DiagramSearchListI[] => {
  return diagramList.map((diagram) => {
    return {
      value: diagram.id.toString(),
      label: diagram.diagram_name.toLowerCase(),
      description: diagram.diagram_description.toLowerCase(),
    };
  });
};

//convert uppercase to first capital letter
/**
 *
 * @param str
 * @returns returns a string with first capital letter and all other letters lowercase
 */
export const capitalizeWord = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
